import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollapsePanelinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.28,
		d: "m10.838 12.506-2.501-2.501 2.501-2.501"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.28,
		d: "M2.501 13.339v-6.67a4.17 4.17 0 0 1 4.168-4.168h6.67a4.17 4.17 0 0 1 4.168 4.168v6.67a4.17 4.17 0 0 1-4.168 4.168h-6.67a4.17 4.17 0 0 1-4.168-4.168"
	})]
});
export default SvgCollapsePanelinline;
